"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHighlightedText = getHighlightedText;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function getHighlightedText(optionText, searchInputValue, classes) {
  var optionTextString = optionText.toString(); // change to string in case numbers are passed as values
  if (!searchInputValue || searchInputValue.trim() === '') {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.standardText
    }, optionTextString);
  }
  var sanitized = searchInputValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  // Split on searchInputValue term and include term into parts, ignore case
  var parts = optionTextString.split(new RegExp("(".concat(sanitized, ")"), 'gi'));
  return parts.map(function (part, index) {
    var _cx;
    var leadingWhitespace = part.charAt(0) === ' ';
    var trailingWhitespace = part.charAt(part.length - 1) === ' ';
    var cleaned = part;
    if (leadingWhitespace) {
      cleaned = cleaned.slice(1);
    }
    if (trailingWhitespace) {
      cleaned = cleaned.slice(0, cleaned.length - 1);
    }
    return /*#__PURE__*/_react["default"].createElement("span", {
      // eslint-disable-next-line react/no-array-index-key
      key: "".concat(part, "-").concat(index),
      className: (0, _classnames["default"])((_cx = {}, (0, _defineProperty2["default"])(_cx, classes.matchedText, part.toLowerCase() === searchInputValue.toLowerCase()), (0, _defineProperty2["default"])(_cx, classes.standardText, part.toLowerCase() !== searchInputValue.toLowerCase()), _cx))
    }, leadingWhitespace && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\xA0"), cleaned, trailingWhitespace && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\xA0"));
  });
}